/**
 * Dynamic CM <-> IN converter for the NEIWAI product size guide modal.
 */
document.addEventListener('DOMContentLoaded', () => {
  const initToggles = () => {
    const toggleInputs = document.querySelectorAll('.js-size-chart-unit-toggle');
    toggleInputs.forEach(input => {
      // Prevent double binding
      if (input.dataset.bound) return;
      input.dataset.bound = "true";

      const container = input.closest('.product-popup-modal');
      if (!container) return;

      const toggleState = () => {
        const isInch = input.checked; // checked = IN, unchecked = CM
        const unit = isInch ? 'in' : 'cm';
        
        // Update labels active styles
        const labelCm = container.querySelector('.sc-toggle-label--cm');
        const labelIn = container.querySelector('.sc-toggle-label--in');
        if (labelCm && labelIn) {
          labelCm.classList.toggle('active', !isInch);
          labelIn.classList.toggle('active', isInch);
        }

        // Toggle table displays inside legacy size_chart_html
        const cmTables = container.querySelectorAll('.cm-table, .table_wrapped table:not(.inches-table):not(.howToMeasure-table)');
        const inTables = container.querySelectorAll('.inches-table');

        if (isInch) {
          cmTables.forEach(t => t.classList.add('hidden'));
          inTables.forEach(t => t.classList.remove('hidden'));
        } else {
          cmTables.forEach(t => t.classList.remove('hidden'));
          inTables.forEach(t => t.classList.add('hidden'));
        }

        // Convert dynamic tables (js-convertible-table)
        const convertibleTables = container.querySelectorAll('.js-convertible-table');
        convertibleTables.forEach(table => {
          const cells = table.querySelectorAll('td');
          cells.forEach(cell => {
            // Skip first cell of each row (column headers/labels like MEASUREMENT)
            if (cell.cellIndex === 0) return;

            // Find or initialize original CM text
            let origCM = cell.getAttribute('data-orig-cm');
            if (origCM === null) {
              origCM = cell.innerHTML.trim();
              cell.setAttribute('data-orig-cm', origCM);
            }

            if (isInch) {
              cell.innerHTML = convertTextToInches(origCM);
            } else {
              cell.innerHTML = origCM;
            }
          });
        });
      };

      input.addEventListener('change', toggleState);
      
      // Initialize immediately
      toggleState();
    });
  };

  /**
   * Helper function to convert numeric values and ranges inside strings (e.g. "63–92" or "80")
   * to Inches (dividing by 2.54 and rounding to 1 decimal place or whole number).
   */
  const convertTextToInches = (text) => {
    // Regex matches integers or decimals (e.g. 63, 92, 10.5)
    // Matches ranges as well (e.g., 63-92, 63–92 with different dashes)
    return text.replace(/([0-9]+(?:\.[0-9]+)?)/g, (match) => {
      const cmVal = parseFloat(match);
      if (isNaN(cmVal)) return match;
      
      const inVal = cmVal / 2.54;
      // Round to nearest 0.5 (e.g. 34.4 -> 34.5, 34.8 -> 35)
      let rounded = Math.round(inVal * 2) / 2;
      
      // If you strictly want 34.6 to round up to 35 instead of 34.5, 
      // we can apply a custom decimal rule. The code below does standard nearest 0.5 rounding.
      return rounded.toString();
    });
  };

  // Run on load
  initToggles();

  // Watch for dynamic insertions (like quick add modals opening)
  const observer = new MutationObserver(() => {
    initToggles();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
